import React, { useCallback } from "react";
import { OrganizationEntityPriority } from "@common/types/organizationEntity";
import { ORGANIZATION_ENTITY_PRIORITY_CONFIG } from "@components/pageHeader/filters/Tabs/PriorityFilter/organizationEntityPriority.constant";
import { Checkbox } from "@design-system/Checkbox/Checkbox";
import { BaseFilterProps } from "../../lib";
import styles from "../CommonFilterTab.module.scss";

const allPriorities = Object.values(OrganizationEntityPriority);

export const PriorityFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const handleChange = useCallback(
        (priority: OrganizationEntityPriority) => {
            if (filters.priority?.includes(priority)) {
                onChange({
                    priority: filters.priority.filter(
                        (p: OrganizationEntityPriority) => p !== priority,
                    ),
                });
            } else {
                onChange({
                    priority: [...(filters.priority ?? []), priority],
                });
            }
        },
        [filters.priority, onChange],
    );

    return (
        <section className={styles.direction}>
            <header className={styles.header}>Priority</header>

            <Checkbox
                label="All"
                checked={!filters.priority || filters.priority.length === 0}
                onCheckedChange={() => onChange({ priority: undefined })}
            />
            {allPriorities.map((priority) => (
                <Checkbox
                    key={priority}
                    label={ORGANIZATION_ENTITY_PRIORITY_CONFIG[priority].label}
                    checked={filters.priority?.includes(priority) ?? false}
                    onCheckedChange={() => handleChange(priority)}
                />
            ))}
        </section>
    );
};
